// extracted by mini-css-extract-plugin
export default {"documents":"ProductDocuments_documents__C71DL"};